import React, { useEffect } from 'react'
import { Btn, CustomCheckbox, CustomDataTableHeader, CustomModal } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'

import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { connect } from 'react-redux'
import useModalAssocDeliveryRoute, { LOAD_MESSAGE } from './ModalAssocRotaEntregaHook'

function ModalAssocRotaEntrega({ onClose, isVisible, customer, selectedTp, dispatch }) {
  const { state, localDispatch } = useModalAssocDeliveryRoute()

  useEffect(() => {
    if (isVisible) localDispatch.onInit(customer)
  }, [customer, isVisible])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.INITIAL_FETCH:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getRotasAssociadas(customer.id, selectedTp)
        break

      case LOAD_MESSAGE.SAVE_ROUTE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.saveRotaEntrega(state.rotaSelecionada, customer.id, selectedTp)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.clearError()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      onClose={onClose}
      isVisible={isVisible}
      header={'Associação Rota de Entrega'}
      width={600}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <Btn onClick={() => localDispatch.onSalvar(customer, state.rotas)}>Salvar</Btn>
        </div>
        <div className="p-col-12">
          <DataTable
            value={!state.rotas ? [] : state.rotas}
            emptyMessage={'Operador Logístico Não possui Rota de Entrega cadastrada'}
            header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
            globalFilter={state.globalFilter}
            rows={10}
            paginator={true}
          >
            <Column
              header={'#'}
              style={tableCellCentered(80)}
              body={rota => (
                <CustomCheckbox
                  checked={rota.selected}
                  onChange={() => localDispatch.onCheckboxClicked(rota, state.rotas)}
                />
              )}
            />
            <Column field={'rota_nome'} header={'Rota'} />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(ModalAssocRotaEntrega)
